import { SxProps, Theme } from '@mui/material/styles';
import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { Color } from 'shared/utils/colors';

export interface AnswerTypeThemeTokens {
  accent: string;
  accentBg: string;
  accentBorder: string;
}

export const ANSWER_TYPE_THEME: Record<AnswerType, AnswerTypeThemeTokens> = {
  [AnswerType.Compliance]: {
    accent: Color.statusSuccessGreen,
    accentBg: Color.successGreenBg08,
    accentBorder: Color.statusSuccessGreen,
  },
  [AnswerType.Numeric]: {
    accent: Color.blue,
    accentBg: Color.blueBg08,
    accentBorder: Color.blue,
  },
  [AnswerType.Text]: {
    accent: Color.primaryOrangeDark,
    accentBg: Color.primaryOrangeLight,
    accentBorder: Color.primaryOrange,
  },
  [AnswerType.OptionSelection]: {
    accent: Color.statusDraftAmber,
    accentBg: Color.statusDraftAmberBg08,
    accentBorder: Color.statusDraftAmber,
  },
};

export function getAnswerTypeTheme(answerType: AnswerType): AnswerTypeThemeTokens {
  return ANSWER_TYPE_THEME[answerType];
}

export function getAnswerTypeChipSx(answerType: AnswerType): SxProps<Theme> {
  const theme = getAnswerTypeTheme(answerType);

  return {
    fontSize: '0.75rem',
    height: 24,
    bgcolor: theme.accentBg,
    color: theme.accent,
    fontWeight: 500,
    borderRadius: 1,
  };
}

export function getAnswerCardSx(answerType: AnswerType): SxProps<Theme> {
  const theme = getAnswerTypeTheme(answerType);

  return {
    border: `1px solid ${Color.border}`,
    borderLeft: `4px solid ${theme.accentBorder}`,
    borderRadius: 1,
    p: 2,
    bgcolor: 'background.paper',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  };
}

export function getRequiredSwitchSx(_answerType: AnswerType): SxProps<Theme> {
  return {
    '& .MuiSwitch-switchBase': {
      color: Color.disabledGray,
      '& + .MuiSwitch-track': {
        bgcolor: Color.disabledGray,
        opacity: 1,
      },
      '&.Mui-checked': {
        color: Color.primaryOrange,
        '& + .MuiSwitch-track': {
          bgcolor: Color.primaryOrangePale,
          opacity: 1,
        },
      },
    },
  };
}

export function getRequiredLabelSx(_answerType: AnswerType): SxProps<Theme> {
  return {
    mx: 0,
    mr: 0,
    '& .MuiFormControlLabel-label': {
      color: Color.black,
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.43,
    },
  };
}

export function getAddOptionButtonSx(answerType: AnswerType): SxProps<Theme> {
  const theme = getAnswerTypeTheme(answerType);

  return {
    color: theme.accent,
    textTransform: 'none',
    fontWeight: 400,
    '&:hover': {
      bgcolor: theme.accentBg,
    },
  };
}
